import { CustomValueOption } from "PFApp/components/custom_value_select/custom_value_select";
import { FormatFunction } from "PFCore/helpers/date_formatter";
import { CustomValue, PureCustomValueData } from "PFTypes";

type CreateCustomValueChangeHandlersParams = {
  values: PureCustomValueData[];
  isMulti: boolean;
  formatISODate: FormatFunction;
  handleChange: (values: PureCustomValueData[]) => void;
};

export const createCustomValueChangeHandlers = ({
  values,
  isMulti,
  formatISODate,
  handleChange
}: CreateCustomValueChangeHandlersParams) => {
  const handleBooleanChange = (value: boolean) => {
    handleChange([{ value } as PureCustomValueData]);
  };

  const handleCalendarChange = (date: string) => {
    // backend does not update date value if it is provided with existing id
    // (contrary to other custom values updates)
    handleChange(date ? [{ value: formatISODate(date) } as PureCustomValueData] : []);
  };

  const handleExpiryDateChange = (option: CustomValueOption) => {
    const newValues = [...values] as CustomValue[];
    const changedValue = newValues.find((value) => value.id === option.id);
    if (changedValue) {
      changedValue.expiryDate = option.original?.expiryDate;
    }
    handleChange(newValues);
  };

  const handleCreate = (createdOption: CustomValueOption) => {
    const newOption = { ...createdOption, created: true };
    const newValues = (isMulti ? [...values, newOption] : [newOption]) as PureCustomValueData[];
    handleChange(newValues);
    return Promise.resolve(createdOption);
  };

  return { handleBooleanChange, handleCalendarChange, handleExpiryDateChange, handleCreate };
};
